<template>
<div>
  <HeadDetailsGama  v-on:save="save" :btnCanceSave="true" :titleHead="'Detalhe do Empreendimento'"></HeadDetailsGama>
 <div id="body-details" class="mt-4 ml-2">
    <div class="">
            <p  class="ml-3 subtitle">Dados Básicos</p>
                <div class="d-flex flex-wrap">
                    <div class="col-md-4 mb-3">
                        <p class="label-details">Nome</p>
                        <input v-model="data.nome" class="input-details" >
                    </div>
                    <div class="col-md-4 mb-3">
                        <p class="label-details">Tipo de Empreendimento</p>
                        <select v-model="data.tipo" name="statusVistoria" class="form-control" id="exampleFormControlSelect2">
                            <option :value="data.tipo == null ?  null : data.tipo"> {{getDescricaoEnum(data.tipo)}}</option>
                            <option v-for="dataop in  getNotIn(data.tipo)" :key="dataop.enum" :value="dataop.enum">{{dataop.descricao}}</option>
                        </select>
                    </div>
                    <div class="col-md-4 mb-3">
                        <p class="label-details">Destaque</p>
                        <b-form-checkbox v-model="data.destaque" size="lg" name="check-button" switch />
                    </div>
                    <div class="col-md-4">
                        <p class="label-details">Data início da obra</p>
                        <!-- <input type="date" class="input-details" v-model="data.dataInicioObra"> -->
                        <b-form-datepicker
                            v-model ="data.dataInicioObra"
                            placeholder="__/__/____"
                            locale="pt-BR"
                            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                        ></b-form-datepicker>
                    </div>
                    <div class="col-md-4">
                        <p class="label-details">Data de Previsão da obra</p>
                        <!-- <input type="date" class="input-details" v-model="data.dataPrevisaoObra"> -->
                        <b-form-datepicker
                            v-model ="data.dataPrevisaoObra"
                            placeholder="__/__/____"
                            locale="pt-BR"
                            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                        ></b-form-datepicker>
                    </div>
                </div>
                <p  class="ml-3 mt-4 subtitle">Endereço</p>
                  <div class="d-flex flex-wrap mt-2">
                        <div class="col-md-2">
                            <p class="label-details">CEP</p>
                             <b-form-input
                              id="input-cep"
                              name="input-cep"
                              v-model="data.cep"
                              v-on:blur="getCepApi"
                              v-validate="{ required: true, numeric: false, length: 9 }"
                              :state="validateState('input-cep')"
                              type="text"
                              placeholder="_____-___"
                              v-mask="['#####-###']"
                              required
                            ></b-form-input>
                        </div>
                        <div class="col-md-3">
                            <p class="label-details">Cidade</p>
                            <input  disabled v-model="data.cidade.nome"  class="input-details" >
                        </div>
                        <div class="col-md-4">
                            <p class="label-details">Endereço</p>
                            <input v-model="data.endereco" class="input-details" disabled>
                        </div>
                        <div class="col-md-3">
                            <p class="label-details">Bairro</p>
                            <input v-model="data.bairro" class="input-details" disabled>
                        </div>
                        <div class="col-md-2 mt-2">
                            <p class="label-details">Número</p>
                            <input v-model="data.numero"  class="input-details" >
                        </div>
                  </div>
                  <div class="d-flex flex-wrap mt-3">
                     <div class="row obs-margem">
                            <label class="obs-letra">Observações</label>
                     </div>
                 </div>
                <div class="d-flex flex-wrap mt-3">
                        <b-container fluid>
                        <b-row class="mt-2">
                            <b-col sm="2">
                            </b-col>
                            <b-col sm="10">
                            <b-form-textarea
                                v-model="data.observacao"
                                id="textarea-large"
                                size="lg"
                                placeholder="Digite a observação"
                            ></b-form-textarea>
                            </b-col>
                        </b-row>
                        </b-container>
                </div>
    </div>
  </div>
</div>
</template>

<script>
import Typeaddressenterprise from './typeaddressenterprise'
export default Typeaddressenterprise
</script>

<style scoped>

#body-details::-webkit-scrollbar-track {
    background-color: #F4F4F4;
}
#body-details::-webkit-scrollbar {
    width: 6px;
    background: #F4F4F4;
}
#body-details::-webkit-scrollbar-thumb {
    background: #dad7d7;
}

.subtitle{
    font-size: 18px;
    color: #008148;
    font-weight: bold;
}
.obs-letra{
    font-size: 15px;
    color: black;
    margin-bottom: 0px;
}
.obs-margem{
    margin-top: 1%;
    margin-left: 1%;
}
textarea.form-control {
    height: 400%;
    margin-left: -229px;
    width: 124%;
    border-radius: 6px;
    margin-top: -17px;
    font-size: 14px;
}
.label-details{
    font-size: 15px;
    color: black;
    margin-bottom: 0px;

}
#body-details{
    height: 60vh;
    overflow: auto;
}
.input-details{
    width: 100%;
    height: 35px;
    background-color: 100%;
    border: 1px solid #D4D9DE;
    border-radius: 5px;
    outline: none;
    padding-left: 1rem;
}

 @media screen and (max-width: 1600px) {
    textarea.form-control {
        height: 400%;
        margin-left: -155px;
        width: 124%;
        border-radius: 6px;
        margin-top: -17px;
        font-size: 14px;
    }
    .obs-letra{
    font-size: 15px;
    margin-left: 5px;
    color: black;
    margin-bottom: 0px;
    }
}

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/enterprise/components/typeaddressenterprise/typeaddressenterprise.vue